import { SettingValue } from '../../../data/model/questionnaire'

export enum SliderInitialPlacement {
  MIDDLE = SettingValue.Middle,
  LEFT = SettingValue.Left,
  RIGHT = SettingValue.Right
}

export const sliderInitialPlacementOptions = [
  {
    id: 'slider_initial_placement_selector_middle',
    name: 'Middle',
    value: SliderInitialPlacement.MIDDLE
  },
  {
    id: 'slider_initial_placement_selector_left',
    name: 'Left',
    value: SliderInitialPlacement.LEFT
  },
  {
    id: 'slider_initial_placement_selector_right',
    name: 'Right',
    value: SliderInitialPlacement.RIGHT
  }
]

export const SLIDER_INITIAL_PLACEMENT_SELECTOR =
  'slider initial placement selector'
